import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutTerminalCodeList extends Layout {
    layoutheaderTerminalCodeList: LayoutHeader;
    sourceTerminalLookup: DataSource;
    tableTerminalCodes: Table;
}
